import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  AreaChart, Tooltip, Area, ResponsiveContainer, XAxis, YAxis,
} from 'recharts';
import { setCurrencyFormat } from '../../../../utils/helpers';

const color = '#007bff';
const CustomTooltip = ({ active, payload }) => {
  if (active) {
    return (
      <div className="dashboard__total-tooltip">
        <p className="label"> {`${setCurrencyFormat(payload?.[0]?.value, true)}`}</p>
      </div>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
  })),
};

CustomTooltip.defaultProps = {
  active: false,
  payload: null,
};

const BTC = ({ dir, dataSet, maxBTCValue }) => {
  const [activeIndex] = useState(0);
  if (dataSet) {
    return (
      <ResponsiveContainer height={70}>
        <AreaChart
          data={dataSet}
          margin={{
            top: 0, left: 0, bottom: 0,
          }}
        >
          <XAxis
            hide
            reversed={dir === 'rtl'}
          />
          <YAxis ticks={[0, maxBTCValue]} hide />
          <Tooltip content={<CustomTooltip />} />
          <Area
            name="BTC"
            type="monotone"
            dataKey="btc"
            fill={color}
            stroke={color}
            fillOpacity={0.2}
          />
        </AreaChart>
      </ResponsiveContainer>

    );
  }
  return 'No Data';
};

BTC.propTypes = {
  dir: PropTypes.string.isRequired,
  dataSet: PropTypes.string.isRequired,
  maxBTCValue: PropTypes.string.isRequired
};

export default BTC;
